const EU_BIRTH_DATE = /^(\d{2})\.(\d{2})\.(\d{4})$/;

function parseBirthDate(birthDate: string): Date | undefined {
  const trimmed = birthDate?.trim();
  if (!trimmed) {
    return undefined;
  }

  const eu = EU_BIRTH_DATE.exec(trimmed);
  if (eu) {
    const day = Number(eu[1]);
    const month = Number(eu[2]);
    const year = Number(eu[3]);
    const parsed = new Date(year, month - 1, day);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }

  const iso = new Date(trimmed);
  if (!Number.isNaN(iso.getTime())) {
    return iso;
  }

  return undefined;
}

function differenceInFullYears(from: Date, to: Date = new Date()): number {
  let years = to.getFullYear() - from.getFullYear();
  const monthDelta = to.getMonth() - from.getMonth();
  if (monthDelta < 0 || (monthDelta === 0 && to.getDate() < from.getDate())) {
    years -= 1;
  }
  return years;
}

/** Full years from Valvur birth dates (`dd.MM.yyyy`) or ISO strings. */
export function childAgeYearsFromBirthDate(
  birthDate: string | null | undefined,
): number | undefined {
  const trimmed = birthDate?.trim();
  if (!trimmed) {
    return undefined;
  }

  const parsed = parseBirthDate(trimmed);
  if (!parsed) {
    return undefined;
  }

  const ageYears = differenceInFullYears(parsed);
  if (ageYears < 0 || ageYears >= 200) {
    return undefined;
  }

  return ageYears;
}
